
  import { mapGetters, mapState } from 'vuex'
  import cms from '~/mixins/common/cms'
  export default {
    name: 'Theme4PopupComponent',
    mixins: [cms],
    data: () => ({
      carouselIndex: 0
    }),
    computed: {
      ...mapGetters({
        getCMS: 'cms/getCMS',
        splashScreen: 'cms/splashScreen',
        maintenance: 'themes/settings/maintenance'
      }),
      ...mapState({
        dialog: state => state.settings.displayPopup,
        loading: state => state.settings.changeLanguageLoading
      }),
      isImageExist() {
        let isExist = false
        if (!this.splashScreen?.items) {
          isExist = false

          return false
        }

        this.splashScreen?.items.forEach(item => {
          const getImage = this.cmsImageLink({
            path: (item?.image_path && item?.image_path[this.handleCookie('wl_locale')]) || '',
            code: this.splashScreen?.component_code
          })
          if (getImage) isExist = true
        })
        return isExist
      }
    },
    methods: {
      closePopup() {
        this.$store.commit('settings/setDisplayPopup', false)
      }
    }
  }
